import $ from "jquery";

$(document).ready(function () {
    $('.js-delivery-details').on('click', function () {
        showDeliveryDetails($(this).attr('data-type'), $(this).attr('data-ticket-category-id'));
    });
});

function showDeliveryDetails(type, ticketCategoryId) {
    $("#noticeModal .modal-body").html($(".delivery_info." + ticketCategoryId + '_' + type).html());
    $("#noticeModal").modal();
}
